import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import CustomizedBreadcrumbs from "../../../components/Custom/CustomizedBreadcrumbs";
import CustomizedMenuList from "../../../components/Custom/CustomizedMenuList";
import { IBreadcrumbsAndMenu } from "../../../types/global";
import { hasPermission } from "../../../utils/Global";
import { useStateContext } from "../../../contexts/auth-context";

const BusinessSetting = () => {
  const { t } = useTranslation();
  const {
    state: { permissions },
  } = useStateContext();

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("setting.index"),
      to: "/setting",
    },
    {
      name: t("setting.business.index"),
    },
  ];

  const menuList: IBreadcrumbsAndMenu[] = [
    {
      name: t("setting.company.index"),
      to: "/setting/business/company",
      permissionKey: "company",
    },
    {
      name: t("branch.index"),
      to: "/setting/business/branch",
      permissionKey: "branch",
    },
    {
      name: t("setting.zone.index"),
      to: "/setting/business/zone",
      permissionKey: "zone",
    },
    {
      name: t("setting.currency.index"),
      to: "/setting/business/currencies",
    },
  ].filter((item) => hasPermission(item.permissionKey, permissions));

  return (
    <Fragment>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <CustomizedMenuList menuList={menuList} />
    </Fragment>
  );
};

export default BusinessSetting;
